/**
 * Implement Gatsby's Browser APIs in this file.
 * @see https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from 'react';
import { ThemeProvider } from '@emotion/react';
import theme from '@front/ds/themes/essayshark.academy';
import '@fontsource/open-sans';
import '@fontsource/open-sans/700.css';
import '@fontsource/lato';
import '@fontsource/lato/700.css';

import { createRoot } from 'react-dom/client';

export const replaceHydrateFunction = () => (element, container) => {
  const root = createRoot(container);
  root.render(element);
};

export const wrapPageElement = ({ element }) => (
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
);

/**
 * @see https://github.com/gatsbyjs/gatsby/issues/23676
 * @returns {Promise<void>}
 */
export const onClientEntry = () => {
  if (typeof IntersectionObserver === 'undefined') {
    return import('intersection-observer');
  }

  return Promise.resolve();
};
